var render = function render(){var _vm=this,_c=_vm._self._c;return _c('google-map',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":_vm.zoomValue}},_vm._l((_vm.markers),function(m,i){return _c('google-marker',{key:i,attrs:{"position":m.position,"clickable":true,"draggable":true},on:{"click":function($event){_vm.center = m.position}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }